import { DirectLinkType } from '@src/domains/direct-links';
import type { Transactable } from '@src/domains/transactables';

// The buyer of an order-type link holds only the link code, so the gateway lifts the ownership check for that Order.
const hasMatchingOrderDirectLink = (tr: Transactable): boolean =>
  tr.directLink?.type === DirectLinkType.Order && tr.directLink.orderId === tr.order?.id;

// SaleChange and Order require a token, except the Order of its own order-type link. Sale can work without one
// (public endpoint for DirectLink).
export const requiresBuyerToken = (tr: Transactable): boolean =>
  Boolean((tr.order && !hasMatchingOrderDirectLink(tr)) || tr.saleChange);
